/* SRC scroll reveal: opacity-only, fires once, per the motion spec.
   Elements opt in with [data-src-reveal]; CSS owns the transition. */
(function () {
  var els = document.querySelectorAll('[data-src-reveal]:not(.src-revealed)');
  if (!els.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    els.forEach(function (el) {
      el.classList.add('src-revealed');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('src-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  els.forEach(function (el) {
    observer.observe(el);
  });
})();
